/**
 * A new Wave id for `ClaimCandidates`. Waves are a client-side batching concept: the service
 * UPSERTs a `motion_waves` row from whatever id the claim carries, and there is no CreateWave call.
 * Opaque 32-char lowercase hex — a UUID with its hyphens dropped, per the model's WaveId pattern.
 */
export function newWaveId(): string {
  return crypto.randomUUID().replace(/-/g, '');
}
